import { z } from 'zod';

import { alphanumericRegex, integerAndFloatNumbersRegex } from 'constants/regex';

const amountMaxValue = 99999.99;

function isFutureDate(date: Date) {
  const currentDate = new Date();
  return date.getTime() > currentDate.getTime();
}

const validationSchema = z.object({
  roofTopId: z.string({ required_error: 'Please select a Dealership' }).uuid(),
  roNumber: z
    .string()
    .min(1, 'Please enter a valid RO Number')
    .regex(alphanumericRegex, { message: 'Only numbers or letters allowed' }),
  roDate: z
    .date({
      required_error: 'Please enter a valid RO Date',
      invalid_type_error: 'Please enter a valid RO Date',
    })
    .refine(selectedDate => !isFutureDate(selectedDate), {
      message: "Future date isn't allowed",
    }),
  claimSubmittedDate: z
    .date()
    .nullable()
    .optional()
    .refine(selectedDate => !selectedDate || !isFutureDate(selectedDate), {
      message: "Future date isn't allowed",
    }),

  lineNumber: z.string().nullable().optional(),
  techNumber: z
    .string({ required_error: 'Please enter a tech number' })
    .min(1, 'Please enter a tech number'),
  advisorNumber: z
    .string({ required_error: 'Please enter an advisor number' })
    .min(1, 'Please enter an advisor number'),
  amount: z
    .string()
    .min(1, 'Please enter a valid Amount')
    .regex(integerAndFloatNumbersRegex, { message: 'Only integer or float numbers allowed' })
    .refine(
      val => {
        const amountValue = parseFloat(val);

        return amountValue <= amountMaxValue;
      },
      { message: 'Please enter amount less or equals to 99999.99' }
    ),
  requestCategoryId: z
    .number({ required_error: 'Please select a Request Category' })
    .min(0, 'Please select a Request Category'),
  claimStatusId: z
    .number({ required_error: 'Please select a Claim status' })
    .min(0, 'Please select a Claim status'),
  ticketPriorityId: z
    .number({ required_error: 'Please select a Priority' })
    .min(0, 'Please select a Priority'),
  text: z.string().nullable(),
});

export default validationSchema;
